export default __webpack_public_path__ + "static/media/vilt.dac910f9.png";